import React from "react";
import style from '../Contacto/Contacto.module.css';

const Contacto = () => {
  return (
    <div className={style.contacto}>
      <a target="_blank" rel="noopener noreferrer" href='https://www.linkedin.com/in/nahuel-federico-rodriguez-76a0891b4/'>
        <img alt="LinkedIn" src="https://cdn0.iconfinder.com/data/icons/social-media-circle-long-shadow/1024/linkedin-256.png" />
      </a>
      <a target="_blank" rel="noopener noreferrer" href='https://github.com/nahuelrodriguez98'>
        <img alt="GitHub" src="https://cdn2.iconfinder.com/data/icons/social-media-iconez/64/GitHub-256.png" />
      </a>

      
    </div>
  );
};

export default Contacto;
